"use client";
import wallpaper from "../../assets/imgs/wall4.jpg"

export default function Wallpaper() {
  return (
    <>
    <div className="absolute inset-0 overflow-hidden" style={{ opacity: 0.49 }}/>
      <img
        src={wallpaper}
        // src={wallpaper}
        alt=""
        className="w-full h-full object-cover"
        draggable={false}
        />
        </>
    
  );
}

// "https://framerusercontent.com/images/EeD4hr0OuMeMkXRA4cayyZJOag.png"